import { Palmtree } from "lucide-react";

export default function Marquee({ items }) {
    return (
        <div aria-hidden="true" className="overflow-hidden border-y border-sand-border bg-sand py-6">
            <div className="flex w-max animate-marquee">
                {[0, 1].map((copy) => (
                    <div key={copy} className="flex items-center">
                        {items.map((text, i) => (
                            <span
                                key={`${copy}-${i}`}
                                className="mx-8 flex items-center gap-8 whitespace-nowrap font-display text-2xl font-light italic text-olive/70 md:text-3xl"
                            >
                                {text}
                                <Palmtree className="h-5 w-5 text-amber/70" strokeWidth={1.5} />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
